import React from "react";

import FormInputNumber from "components/Form/Input/Number";
import FormTitle from "components/Form/Title";
import FormErrors from "pages/ApplicationForm/components/FormErrors";
import { StepProps } from "../../types";
import { LABELS } from "./labels";

const STEP_KEY = "other";

const OtherDetailsForm: React.FC<StepProps> = ({
  control,
  register,
  errors,
}) => {
  return (
    <div className="flex flex-col space-y-4">
      <FormTitle left border title="Other Details" mb={false} />

      <FormErrors formErrors={errors?.[STEP_KEY]} />

      <FormInputNumber
        id={`${STEP_KEY}.numberOfFinancialDependents17Under`}
        label={LABELS.numberOfFinancialDependents17Under}
        register={register}
        error={errors?.[STEP_KEY]?.numberOfFinancialDependents17Under?.message}
      />

      <FormInputNumber
        id={`${STEP_KEY}.numberOfFinancialDependentsOver17`}
        label={LABELS.numberOfFinancialDependentsOver17}
        register={register}
        error={errors?.[STEP_KEY]?.numberOfFinancialDependentsOver17?.message}
      />
    </div>
  );
};

export default OtherDetailsForm;
